import React, {Fragment, useState} from 'react';
import {Button} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import {CreateUserModal} from "../modals/CreateUser";
import { ACL } from '../../../../../../config/constants';
import { store } from '../../../../../../store/store';
import { hideNotification } from '../../../../../../store/actions/notification';

const CreateUser = (props) => {
  const hasPermission = () => {
    return ACL.ADMIN.USERS.CREATE.hasAccess();
  }

  const [state, setState] = useState({
    showModal: false
  })

  if (!hasPermission()) {
    return null;
  }

  return (
    <Fragment>
      <Button
        className="btn-warning"
        color="primary"
        onClick={() => {
          store.dispatch(hideNotification());
          setState({
            ...state,
            showModal: true
          })
        }}
        size="sm"
      >
        <FormattedMessage
          id="components.pages.admin.users.buttons.create_user"/>
      </Button>

      <CreateUserModal
        showModal={state.showModal}
        actionCallback={props.actionCallback}
        closeModal={
          () => setState({
            ...state,
            showModal: false
          })
        }

      />
    </Fragment>
  )
}

export {
  CreateUser
};

